<template>
   <!-- 卡片式组合商品 -->
  <div
    class="grouped_products_card"
    :class="(group_products_position == 'below'||group_products_position == 'foot') && !isMobile() ? 'card_below':'' ">
    <!-- 标题 -->
    <h3 class="title_font2 grouped_products_card__title text-uppercase">
      {{group_products_title }}
      <span class="grouped_products_card__title__discounts d-block" v-if="discounts_tips">{{discounts_tips.onOff?discounts_tips.tips_success:discounts_tips.tips_fail}}</span>
    </h3>
    <div
      style="margin: 4px 0 0px;"
      class="card_body"
      >
      <!-- 组合商品列表 -->
      <div class="content">
        <el-checkbox-group
          v-model="productChecked"
          class="grouped_products_card__product"

          :style="(group_products_position!='below'&&group_products_position!='foot') || isMobile()? 'flex-wrap: wrap;':''">
          <!--每项商品  -->
          <template  v-for="(item, index) in group_products_position ==='button_above'?[...group_product]:[ product, ...group_product ]">
            <div
              :key="item.ID"
              :class="(group_products_position!='below'&&group_products_position!='foot'? index!=0&& index !=3 : index!=0 )  ? index==3&&isMobile()?'grouped_products_card__product__noDot':'grouped_products_card__product__hasDot':'grouped_products_card__product__noDot'">
              <!-- 加号，除第一项的都有 -->
              <div
                class="dot"
                :style="(group_products_position!='below'&&group_products_position!='foot')||isMobile()? 'width: 20px;':'width: 36px;'"
                v-if="group_products_position!='below'&&group_products_position!='foot'? index!=0&& index !=3 : index!=0 ">
                <div
                  class="addicon" >
                  <div class="addicon__row"></div>
                  <div class="addicon__col"></div>
                </div>
              </div>
              <el-checkbox
                :label="item.ID"
                :checked="sub_stock[`product_${item.ID}`]"
                :disabled="!sub_stock[`product_${item.ID}`]">
                <!-- 商品 -->
                <div class="itemProduct">
                  <!-- 商品图片 -->
                  <div class="itemProduct__img" >
                    <a :href="'/products/'+featureImageId[index].post_name" >
                       <v-img-card
                        :data_src="featureImageId[index].thumbnail"
                        :data_url="featureImageId[index].url"
                        padding_top="80%"
                      ></v-img-card>

                      <!-- 商品未选中的蒙版 -->
                      <div v-if="!isCheck(item)" class="img_mask">
                        <span v-if="!sub_stock[`product_${item.ID}`]">{{$t('detail.sold_out')}}</span>
                      </div>
                    </a>
                  </div>
                  <!-- 商品名称 -->
                  <div class="itemProduct__title">
                    <span>
                      <a :href="'/products/'+item.post_name">{{item.post_title}}</a>
                    </span>
                  </div>
                  <!-- 商品卡片高度的填充 -->
                  <div style="flex-grow: 1;"></div>
                  <!-- 商品变种 -->
                  <div
                    class="itemProduct__select"
                    v-if="item.variants&&item.variants.length>1">
                    <select
                      v-model="variant[`product_${item.ID}`]"
                      @change="changevariant(item.variants,item.ID,item)"
                      :name="variant[`product_${item.ID}`]"
                      class="secondary_title product-groups-select"
                    >
                      <option
                        v-for="subitem in item.variants"
                        :key="subitem.ID"
                        :value="subitem.ID">
                        <span
                          v-for="(option, optionindex) in subitem.attrs"
                          :key="subitem.ID + optionindex + option.value">
                          {{optionindex == subitem.attrs.length - 1 ? option.value : option.value + " / "}}
                        </span>
                      </option>
                    </select>
                    <svg
                      style="width: 12px;position: relative;right: 25px;color: rgb(153, 153, 153);"
                      class="Icon Icon--select-arrow"
                      role="presentation"
                      viewBox="0 0 19 12"
                    >
                      <polyline
                        fill="none"
                        stroke="currentColor"
                        points="17 2 9.5 10 2 2"
                        fill-rule="evenodd"
                        stroke-width="2"
                        stroke-linecap="square"
                      />
                    </svg>
                  </div>
                  <div class="itemProduct__num" :class="{'narrowerscreen':(group_products_position !== 'below' && group_products_position !== 'foot')&&narrowerscreen}">
                     <span>Quantity</span>
                      <v-inputnum
                        mode="notBoder"
                        v-model="num[`product_${item.ID}`]"
                        :min="1"
                        :step="1"
                      ></v-inputnum>
                  </div>
                  <!-- 商品价格 -->
                  <div class="itemProduct__price">
                    <v-selectprice
                      class="selectprice"
                      :font-size="14"
                      :regular-font-size="14"
                      :disable_select="true"
                      :currency_style="currency_style"
                      :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
                      :price="price[`product_${item.ID}`]"
                      fontSize="14"
                    ></v-selectprice>
                  </div>
                </div>
              </el-checkbox>
            </div>
          </template>
        </el-checkbox-group>
      </div>
      <!-- 加购 -->
      <div
        v-if="group_products_position != 'button_above'"
        class="grouped_products_card__total add"
        :style="{
          width: (group_products_position != 'below' && group_products_position != 'foot') || isMobile() ? '100%' : 'max-content',
        }">
        <!-- 总价 -->
        <div
          v-if="checkedProduct.length>0"
          class="total_price text-left"
          >
          <span class="total_price__title">{{$t('combined.total_price')}}：</span>
          <v-selectprice
            :font-size="14"
            :regular-font-size="14"
            :disable_select="true"
            :currency_style="currency_style"
            :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
            :price="priceTotal.priceSum"
            :regular_price_num="priceTotal.regularPriceSum>priceTotal.priceSum?priceTotal.regularPriceSum:''"
            fontSize="14"
          ></v-selectprice>
          <div v-if="discounts_tips&&discounts_tips.onOff" style="color:#666">
            {{discounts_tips.price_tips_success}}
          </div>
        </div>
        <!-- 未选择加购商品的提示 -->
        <div
          class="total_tip"
          v-if="checkedProduct.length===0 && !all_stock">
          {{$t('combined.select_one')}}
        </div>
        <div
          class="product-groups-tips page_text_font"
          v-if="all_stock">
          {{$t('detail.sold_out')}}
        </div>
        <!-- 按钮 -->
        <el-button
          class="gocart secondary_title text-uppercase "
          :class="[
            checkedProduct.length===0?'soldout':'gocart',

          ]"
          type="button"
          native-type="submit"
          :loading="loading"
          :disabled="checkedProduct.length===0"
          @click="addcart"
          :style="{
            color:group_product_all.text_color,
            background:group_product_all.background_color,
            display:'inline-flex',
            borderColor:group_product_all.background_color
          }"
        >{{group_product_all.button_text}}</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import vInputnum from "@/views/venue/js/common/inputnum.vue";
import vImgCard from '@/js/components/common/imgCard.vue';

export default {
  props:[
    'group_products_title',
    'checkedProduct',
    'product',
    'group_product',
    'group_products_position',
    'sub_stock',
    'featureImageId',
    'changevariant',
    'variant',
    'currency_style',
    'show_currency_selector',
    'priceTotal',
    'loading',
    'addcart',
    'group_product_all',
    'theme',
    'price',
    'num',
    'all_stock',
    "discounts_tips",
    "narrowerscreen"
  ],
  data(){
    return{
      productChecked:this.checkedProduct
    }
  },
  methods:{
    //判断是否为移动端
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    //判断是否选择中的商品
    isCheck(val){
      let id = val.ID
      for(const item of this.checkedProduct){
        if(id == item){
          return true
        }
      }
      return false
    }
  },
  watch:{
    checkedProduct:{
      handler(newV){
         this.productChecked = newV
      },
      deep:true,
      immediate:true
    },
    productChecked(val){
      this.$emit("updatecheckedProduct",val)
    }
  },
  components: {
    vInputnum,
    vImgCard,
  },
}
</script>

<style scoped lang="scss">
//组合商品的卡片式样式
.grouped_products_card{
  margin-top: 20px;
  &__title{
    text-align:left;
    font-size:16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #262626;
    margin-top: 20px;
    &__discounts{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      text-transform:initial;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 20px;
    }
  }
  &__product{
    display: flex;
    flex-direction: row;

    &__hasDot{
      width: calc((100% - 40px) / 3 + 20px);
      display: flex;
      flex-direction: row;
      .dot{
        margin: 30% 0;

        text-align: center;
        // width: calc(100% / 7);
        font-size: 24px !important;
        line-height: 24px !important;
        .addicon{
          width: 16px;
          margin: 0 auto;
          // margin: 49.5px auto 0px;
          &__row{
            width: 16px;
            height: 3px;
            background: #454545;
            border-radius: 1px;
            position: relative;
            top: 9px;
          }
          &__col{
            width: 3px;
            height: 16px;
            background: #454545;
            border-radius: 1px;
            position: relative;
            top: 0px;
            left: 6px;
          }
        }
      }

    }
    &__noDot{
      width: calc((100% - 40px) / 3);
      .el-checkbox{
        width: 100%;
      }
    }
    &__hasDot, &__noDot{
      margin: 10px 0;
      &::v-deep{
        .el-checkbox{
          margin: 0;
          width: 100%;
          height: 100%;
          background: #FAFBFD;
          .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            background: var(--addBtnColor) !important;
            border-radius: 1px !important;
            border: 1px solid var(--addBtnColor) !important;
          }
          .el-checkbox__input.is-disabled .el-checkbox__inner{
            background-color: #ffffff !important;
          }
          .el-checkbox__inner::after{
            border: 1px solid var(--addTextColor) !important;
            border-top: 0 !important;
            border-left: 0 !important;
          }
          &__input{
            position: absolute;
            bottom: 12px;
            left: 10px;
            z-index: 10;
            line-height: 10px !important;
          }
          &__inner{
              width: 16px !important;
              height: 16px !important;
              border-radius: 1px !important;
              border: 1px solid #CCCCCC ;
          }
          &__inner::after{
            width: 4px !important;
            height: 9px !important;
            left: 4px !important;
            top:  0 !important;
          }
          &__label{
            display: flex;
            flex-direction: column;
            padding: 0;
            height: 100%;
            .itemProduct{
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              &__img{
                // height: 99px;
                // max-height: 99px;
                a{
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                  img{
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                  }
                  .img_mask{
                    width: 100%;
                    height: 100%;
                    background: rgba(216, 216, 216, 0.5) !important;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    padding: 0 12px;
                    span{
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #222222;
                      line-height: 20px;
                      text-align: center;
                      width: 100%;
                      border: 1px solid #222222;
                    }
                  }
                  div{
                    width: 100%;
                    height: 99px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    padding: 0 12px;
                    img{
                      top: 50% !important;
                      left: 50% !important;
                      transform: translate(-50%, -50%) !important;
                    }


                  }
                }
              }
              &__title{
                margin: 6px 8px 0;
                text-align: center;
                span{
                  white-space: normal;
                  word-break: break-all;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  color: #000000 !important;
                  a{
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    line-height: 20px;
                  }
                }
              }
              &__select{
                margin: 8px 8px 4px 8px;
                select{
                  -webkit-appearance: none;
                  -moz-appearance: none;
                  appearance: none;
                  width: 100%;
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: left;
                  -moz-text-align-last: left;
                  text-align-last: left;
                  background: #ffffff;
                  border: 1px solid rgba(17, 17, 17, 0.2);
                  font-size: 14px;
                  padding-right: 26px;
                  padding-left: 6px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #222222;
                  line-height: 20px;
                  height: 24px;
                }
              }
              &__price{
                margin:6px 8px 10px;
                display: flex;
                justify-content: flex-end;
                height: 20px;
                div{
                  max-width: calc(100% - 20px);
                }
                .product_price_price{
                  font-size: 14px !important;
                  .price_text{
                    position: relative;
                    z-index: 98;
                  }
                }
              }
              &__num {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                margin: 4px 8px;
                & > span {
                  margin-right: 8px;
                  line-height: 26px;
                  color: #333;
                }
                .product_qty {
                  min-width: 65px;
                  height: 24px;
                  .subtract,
                  .add {
                    line-height: 24px;
                  }
                }
              }
              .narrowerscreen{
                margin: 0px 8px 4px;
                .product_qty{
                  flex: 1;
                }
              }
            }
          }
        }
      }
    }
  }
  &__total{
    margin: 8px 0 20px;
    // padding: 0 !important;
    .total_price{
      margin-bottom: 8px;
      &__title{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        line-height: 20px;
      }
    }
    .total_tip{
      background: #fff1f0;
      border: 1px solid #ffa39e;
      text-align: center;
      padding: 0.35rem 0;
      width: 100%;
      border-radius: 3px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #585858;
      line-height: 20px;
      margin-bottom: 12px;
    }
    button{
      width: 100% !important;
      margin: 0px 0px 20px 0 !important;
      border-radius: 0 !important;
      height: 50px;
      line-height: 20px !important;
      display: inline-flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      &::v-deep span{
        white-space: normal;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.card_below{
  margin: 60px 0 !important;
  .card_body{
    // display: flex;
    align-items: center;
    // .content, .add{
    //   // width: 50% !important;
    // }
    .add{
      text-align: center;
      .total_price{
        margin: 0 auto 12px !important;
      }
    }
  }
  .grouped_products_card__product__noDot{
    width: calc((100% - 150px) / 6 ) ;

  }
  .grouped_products_card__product__hasDot{
    width: calc((100% - 180px) / 6 + 36px) ;
  }
  .el-checkbox{
    width: 100%;
  }
  .gocart{
    max-width: 640px;
    min-width: 300px;
    button{
      height: 50px !important;
    }
  }

}

@media screen and (max-width: 575px) {
  .grouped_products_card{
     &::v-deep{
          .el-checkbox{
            &__input{
              left: 4px !important;
              }
            }
          }
    .itemProduct{
      &__img{
        a{
          div{
            padding: 0 5px !important;
          }
        }
      }
      &__select{
        margin: 8px 4px 4px !important;
      }
      &__price{
        margin:6px 4px 10px !important;
        .selectprice{
          max-width: calc(100% - 18px) !important;
        }
      }
      &__num{
        margin: 0 4px !important;
        .product_qty{
          flex: 1;
        }
      }
    }
    &__total{
      margin: 8px 0 20px !important;
      .total_price{
        margin-bottom: 8px !important;
        text-align: center;
      }
    }
  }

}

</style>
